import RootState from '../../state'
import { GetLens } from '../../types/core'
import State from '../activities/state'

const rootLens: GetLens<RootState, State> = state => () => state.customerAdverts

export default rootLens
